import {
  faApartment,
  faBed,
  faBicycle,
  faBuilding,
  faBuildingMagnifyingGlass,
  faBus,
  faFamily,
  faGraduationCap,
  faHome,
  faIslandTropical,
  faLock,
  faMagnifyingGlass,
  faMars,
  faNonBinary,
  faPeoplePants,
  faPerson,
  faSchool,
  faUser,
  faUsers,
  faVenus,
} from "@fortawesome/pro-solid-svg-icons";

export default [
  {
    id: "gender",
    question: "Wat is je gender?",
    startIndex: 1,
    options: [
      {
        name: "Vrouw",
        icon: faVenus,
        color: "#B84F9A",
      },
      {
        name: "Man",
        icon: faMars,
        color: "#1C71B4",
      },
      {
        name: "Anders",
        icon: faNonBinary,
        color: "#FFCE0E",
      },
      {
        name: "Zeg ik liever niet",
        icon: faLock,
        color: "#339898",
      },
    ],
  },
  {
    id: "educationLevel",
    question: "Wat is je hoogst afgeronde opleidingstype?",
    startIndex: 2,
    options: [
      {
        name: "Geen of basisonderwijs",
        icon: faSchool,
        color: "#A95598",
      },
      {
        name: "Middelbaar onderwijs (vmbo, havo, vwo)",
        icon: faBicycle,
        color: "#396FB0",
      },
      {
        name: "Middelbaar beroeps onderwijs (MBO)",
        icon: faBus,
        color: "#FFCE0E",
      },
      {
        name: "Hoger beroeps onderwijs (HBO)",
        icon: faBuilding,
        color: "#549697",
      },
      {
        name: "Wetenschappelijk onderwijs (WO)",
        icon: faBuildingMagnifyingGlass,
        color: "#DA695D",
      },
      {
        name: "Doctoraat",
        icon: faGraduationCap,
        color: "#5F5F6D",
      },
    ],
  },
  {
    id: "employmentStatus",
    startIndex: 2,
    question: "Wat is je werksituatie?",
    options: [
      {
        name: "Werknemer in loondienst",
        icon: faUsers,
        color: "#396FB0",
      },
      {
        name: "(Zelfstandig) ondernemer",
        icon: faUser,
        color: "#A95598",
      },
      {
        name: "Werkloos en op zoek naar werk",
        icon: faMagnifyingGlass,
        color: "#5F5F6D",
      },
      {
        name: "Werkloos en niet op zoek naar werk",
        icon: faHome,
        color: "#F6D041",
      },
      {
        name: "Arbeidsongeschikt",
        icon: faBed,
        color: "#DA695D",
      },
      {
        name: "Gepensioneerd",
        icon: faIslandTropical,
        color: "#549697",
      },
    ],
  },
  {
    id: "housingType",
    startIndex: 1,
    question: "Wat is je huisvestingstype?",
    options: [
      {
        name: "Huurwoning",
        icon: faBuilding,
        color: "#396FB0",
      },
      {
        name: "Sociale huur",
        icon: faApartment,
        color: "#549697",
      },
      {
        name: "Koopwoning",
        icon: faHome,
        color: "#A95598",
      },
      {
        name: "Overig (bijv. inwonend, onzelfstandig, collectief wonen)",
        icon: faUsers,
        color: "#F6D041",
      },
    ],
  },
  {
    id: "livingSituation",
    startIndex: 2,
    question: "Wat is je huishoudsamenstelling?",
    options: [
      {
        name: "Eén persoonshuishouden",
        icon: faPerson,
        color: "#F6D041",
      },
      {
        name: "Eén ouderhuishouden",
        icon: faFamily,
        color: "#549697",
      },
      {
        name: "Huishouden met paar met kinderen",
        icon: faFamily,
        color: "#A95598",
      },
      {
        name: "Huishouden met paar zonder kinderen",
        icon: faPeoplePants,
        color: "#396FB0",
      },
      {
        name: "Overig huishouden (bijv. met huisgenoten, ouders, gastgezin)",
        icon: faUsers,
        color: "#DA695D",
      },
    ],
  },
];
